/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { fetchCustomers } from './api';
import { createGetStateFromUrl, createPushStateToUrl } from '../util';
import { isEquivalent } from './util';

export const buildActions = (
	namespace,
	rootSliceKey,
	mainRedux,
	mySelectors,
	filtersStatePropKey,
	filterStatePropKey = 'psqlcustomers'
) => {
	const { setIsLoadingFilters, setIsLoadedFilters } = mainRedux.actions;
	const { selectSliceState, selectIsAnyFilterLoading } = mainRedux.selectors;
	const { selectPsqlCustomerSelectedList } = mySelectors;

	const getStateFromUrl = createGetStateFromUrl(
		namespace,
		rootSliceKey,
		filtersStatePropKey,
		filterStatePropKey
	);

	const pushStateToUrl = createPushStateToUrl(
		namespace,
		rootSliceKey,
		filtersStatePropKey,
		filterStatePropKey
	);

	const {
		reInitStatePsqlCustomers,
		requestPsqlCustomers,
		receivePsqlCustomers,
		clearSelectedPsqlCustomers,
		setSelectedPsqlCustomers,
		addSelectedPsqlCustomer,
		removeSelectedPsqlCustomer,
		setLoadPsqlCustomersErrorMessage,
		clearLoadPsqlCustomersErrorMessage
	} = createActions(
		{
			RE_INIT_STATE_PSQL_CUSTOMERS: () => ({}),
			REQUEST_PSQL_CUSTOMERS: () => ({}),
			RECEIVE_PSQL_CUSTOMERS: list => ({ list }),
			CLEAR_SELECTED_PSQL_CUSTOMERS: () => ({}),
			SET_SELECTED_PSQL_CUSTOMERS: (selectedList = []) => ({ selectedList }),
			ADD_SELECTED_PSQL_CUSTOMER: item => ({ item }),
			REMOVE_SELECTED_PSQL_CUSTOMER: item => ({ item }),
			SET_LOAD_PSQL_CUSTOMERS_ERROR_MESSAGE: message => ({ message }),
			CLEAR_LOAD_PSQL_CUSTOMERS_ERROR_MESSAGE: () => ({})
		},
		{ prefix: namespace }
	);

	const getSelectedFromUrl = getState => {
		const sliceState = selectSliceState(getState());
		const list = mySelectors.selectPsqlCustomerList(sliceState);
		const urlSelected = (getStateFromUrl() || {}).selected || [];
		const selectedList = urlSelected
			.map(i => list.find(i2 => isEquivalent(i, i2)))
			.filter(v => !!v);
		return selectedList;
	};

	const thunkLoadPsqlCustomers = () => (dispatch, getState) => {
		dispatch(reInitStatePsqlCustomers());
		dispatch(requestPsqlCustomers());
		dispatch(setIsLoadingFilters(true));

		fetchCustomers((err, list) => {
			dispatch(receivePsqlCustomers(list));
			const selectedList = getSelectedFromUrl(getState);
			dispatch(setSelectedPsqlCustomers(selectedList));
			const sliceState = selectSliceState(getState());
			if (!selectIsAnyFilterLoading(sliceState)) {
				dispatch(setIsLoadingFilters(false));
				dispatch(setIsLoadedFilters(true));
			}
		});
	};

	const _toggleCustomer = item => (dispatch, getState) => {
		const sliceState = selectSliceState(getState());
		const selected = selectPsqlCustomerSelectedList(sliceState);
		const isSelected = selected.indexOf(item) > -1;
		if (isSelected) {
			dispatch(removeSelectedPsqlCustomer(item));
		} else {
			dispatch(addSelectedPsqlCustomer(item));
		}
	};

	const createWithUrlSideAffect = fnAction => (...args) => (
		dispatch,
		getState
	) => {
		dispatch(fnAction(...args));
		const sliceState = selectSliceState(getState());
		const filterState = mySelectors.selectPsqlCustomerFilterState(sliceState);
		pushStateToUrl(filterState);
	};

	const thunkClearSelectedPsqlCustomers = createWithUrlSideAffect(
		clearSelectedPsqlCustomers
	);
	const thunkSetSelectedPsqlCustomers = createWithUrlSideAffect(
		setSelectedPsqlCustomers
	);
	const thunkAddSelectedPsqlCustomer = createWithUrlSideAffect(addSelectedPsqlCustomer);
	const thunkRemoveSelectedPsqlCustomer = createWithUrlSideAffect(
		removeSelectedPsqlCustomer
	);
	const togglePsqlCustomer = createWithUrlSideAffect(_toggleCustomer);
	return {
		reInitStatePsqlCustomers,
		requestPsqlCustomers,
		receivePsqlCustomers,
		clearSelectedPsqlCustomers,
		setSelectedPsqlCustomers,
		addSelectedPsqlCustomer,
		removeSelectedPsqlCustomer,
		setLoadPsqlCustomersErrorMessage,
		clearLoadPsqlCustomersErrorMessage,
		togglePsqlCustomer,
		thunkLoadPsqlCustomers,
		thunkClearSelectedPsqlCustomers,
		thunkSetSelectedPsqlCustomers,
		thunkAddSelectedPsqlCustomer,
		thunkRemoveSelectedPsqlCustomer
	};
};

export default {
	buildActions
};
